<template>
    <div class="modal fade scv-error-report-modal" :id="id" tabindex="-1" role="dialog" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scv" role="document">
            <div class="modal-content modal-content-scv">
                <div class="modal-header modal-header-scv-cmn" style="width: 100%">
                    <div class="modal-header-text-box-scv" style="width: 100%">
                        <span class="modal-header-text-scv">{{props.errorRepoortTitle}}</span>
                    </div>
                </div>
                <div class="modal-body modal-body-scv">
                    <div class="d-flex flex-row align-items-center">
                        <img :src="getIcon" height="24" style="margin-right: 8px" />
                        <span>{{getMessage}}</span>
                    </div>
                    <textarea :id=reportAreaId class="input-text-scv text-area" :value="props.errorReportText" style="margin-top: 8px;" readonly></textarea>
                </div>
                <div class="modal-footer modal-footer-scv">
                    <div class="d-flex justify-content-center">
                        <div zero-font>
                            <button type="button" class="btn-scv-blue" @click="onClipboard">クリップボードにコピー</button>
                            <button type="button" class="btn-scv-white" @click="onClose" style="margin-left: 40px;">閉じる</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- メッセージボックス -->
    <MessageDialog ref="messageDialog" :messageType="messageType" :messageText="messageText" />
</template>

<script setup lang="ts">
import $ from "jquery";
import { ref, Ref, onMounted, nextTick, computed } from 'vue'
import '@/assets/css/icons.css'
import { ErrorReportType } from '@/models/ErrorReport/ErrorReportType';
import { MessageText } from '@/models/Message/MessageText';
import { MessageType } from '@/models/Message/MessageType';
import MessageDialog from '@/components/MessageDialog.vue';
import { BootstrapUtil } from "lib-vue-v2/util";
import guideInfoSvg from "@/assets/img/guide_info_color.svg";
import alertSvg from "@/assets/img/alert_color.svg";

interface Props {
    errorReportType: number;    // [in]（必須）エラーレポート種別
    errorRepoortTitle: string;  // [in]（必須）エラーレポートタイトル
    errorReportText: string;    // [in]（必須）エラーレポート内容
    id?: string;                // id 1画面に複数使用する箇所がある場合は必須
}
const props = withDefaults(defineProps<Props>(), {
    id: "errorReport",
});

interface Emits {
    (event: "onSelectClose"): void;
    /**
     * 非表示になったことを通知します。
     */
    (event: "hidden"): void;
}
const emit = defineEmits<Emits>();

const getMessage = computed(() => {
    if (props.errorReportType === ErrorReportType.Complete) {
        return "インポートが完了しました。";
    }
    return "ファイルのインポートに失敗しました。";
});

const getIcon = computed(() => {
    if (props.errorReportType === ErrorReportType.Complete) {
        return guideInfoSvg;
    }
    return alertSvg;
});

const messageDialog: Ref<MessageDialog | null> = ref(null);

// 表示するメッセージ
const messageType = ref(MessageType.Information);
const messageText = ref("");

const reportAreaId = ref("errorReport");

/**
 * @brief	mounted
 */
onMounted(() => {
    reportAreaId.value = `${props.id}_reportArea`;
    const el = document.getElementById(props.id);
    if (null != el) {
        el.addEventListener("shown.bs.modal", () => {
            el.focus();
            nextTick(() => {
                let element = document.getElementById(reportAreaId.value) as HTMLInputElement;
                element.scrollTop = 0;
            });
        });
        el.addEventListener("hidden.bs.modal", () => {
            emit("hidden");
        });
    }
});

/**
 * @brief   エラーレポートの「閉じる」ボタン押下イベントハンドラ
 */
function onClose(): void {
    BootstrapUtil.hideModal(props.id);
    emit('onSelectClose');
}

/**
 * @brief   エラーレポートの「クリップボードにコピー」ボタン押下イベントハンドラ
 */
function onClipboard(): void {
    // コピーのイベントが発生したときに、クリップボードに書き込むようにしておく
    document.addEventListener("copy", clipboardListener);
    // コピー
    if (document.execCommand("copy") === false) {
        messageType.value = MessageType.Error;
        messageText.value = MessageText.copyToClipboardIsFailed;
        if (messageDialog.value) {
            BootstrapUtil.showModal(messageDialog.value.GetID());
        }
    }
}

/**
 * @brief   クリップボードコピーのイベントリスナー
 */
function clipboardListener(e: any): void {
    const text = $('#' + reportAreaId.value).val();

    e.clipboardData.setData("text/plain", text);

    e.preventDefault();
    document.removeEventListener("copy", clipboardListener);

    messageType.value = MessageType.Information;
    messageText.value = MessageText.copyToClipboard;
    if (messageDialog.value) {
        BootstrapUtil.showModal(messageDialog.value.GetID());
    }
}
</script>

<style scoped>
    .scv-error-report-modal .modal-content {
        width: 800px;
        min-height: 500px;
    }

    .text-area {
        width: 100%;
        min-height: 400px;
        height: 400px;
    }
</style>
